import { useState } from "react";
import useFetch from "../../hooks/useFetch";
import SideBar from "../../layouts/SideBar";
const list_notification = [
    'Thông báo về việc đăng ký môn học học kỳ II, năm học 2023-2024',
    'Thông báo về việc đăng kí môn học bổ sung học kỳ phụ năm học 2022-2023',
    'Lịch thi của SV không chọn hình thức thi trực tuyến học kì 2 năm học 2020-2021',
    'Thông báo lịch thi của các sinh viên hoãn thi, xin thi lại học kì 1 năm học 2022-2023',
    'Lịch thi của SV hoãn thi được thi lại (bổ sung) – HK2, năm học 2021-2022'
]
export default function Notification() {
   // const [listNotification, setListNotification] = useState<
    return (
        <section className="notification-page">
            <div className="page-main flex gap-12">
                <div className="w-4/6">
                    <div className="home-title w-6/6">Thông báo</div>
                    <div className="mt-2">
                        {list_notification.map((item, index) => {
                            return (
                                <div className="noti-item flex gap-4 mt-2">
                                    <div className="noti-day">23/11/2023</div>
                                    <div className="noti-content flex justify-center h-full items-center">{item}</div>
                                </div>
                            )
                        })}
                    </div>
                </div>
                <SideBar />
            </div>
        </section>
    )
}